import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined'
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined'

const general = {
  id: 'general',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'menu:home',
      type: 'item',
      url: '/',
      icon: HomeOutlinedIcon,
      breadcrumbs: false,
    },
    {
      id: 'orders',
      title: 'menu:orders',
      type: 'item',
      url: '/orders',
      icon: ShoppingBagOutlinedIcon,
      breadcrumbs: false,
    },
    {
      id: 'profile',
      title: 'menu:profile',
      type: 'item',
      url: '/profile',
      icon: PersonOutlineOutlinedIcon,
      breadcrumbs: false,
    },
  ],
}

export default general
